/**
 * @auth 赖传峰
 * @date 2022/1/21
 */
const category = 'web_yunpan_login'
export default {
  web_login_page_show: () => {
    window.stat(category, 'web_login_page_show', { emphasize_mode: window.getLoginEmphasize?.() || 'oauth' })
  },
  /**
   * @param scene cloud_page 未登录默认缺省页 landing_page 落地页调起登录 payment_page  支付页
   */
  web_free_premium_pop_show: (scene: 'cloud_page' | 'landing_page' | 'payment_page') =>
    window.stat(category, 'web_free_premium_pop_show', { scene }),
  web_login_page_close(scene: string) {
    window.stat(category, 'web_login_page_close', { scene, emphasize_mode: window.getLoginEmphasize?.() || 'oauth' })
  },
}
